module.exports = __webpack_public_path__ + "img/bianjie4.4a12c255.png";